import { create } from 'zustand';

interface DashboardUIState {
  periodo: string;
  cantidadMeses: number;
  selectedMonths: string[];
  anio: string;

  setPeriodo: (value: string) => void;
  setCantidadMeses: (value: number) => void;
  setSelectedMonths: (value: string[]) => void;
  setAnio: (value: string) => void;

  reset: () => void;
}

const initialState = {
  periodo: '',
  cantidadMeses: 6,
  selectedMonths: [] as string[],
  anio: '',
};

export const useDashboardUIStore = create<DashboardUIState>((set) => ({
  ...initialState,

  setPeriodo: periodo => set({ periodo }),
  setCantidadMeses: cantidadMeses => set({ cantidadMeses }),
  setSelectedMonths: selectedMonths => set({ selectedMonths }),
  setAnio: anio => set({ anio }),

  reset: () => set(initialState),
}));
